export const computeRecipeProductionTotal = (producedQuantity, quantity) =>
  parseFloat(producedQuantity) + parseFloat(quantity);
